import React, { ReactElement } from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import { Field } from 'react-final-form';
import image from '../../../../../img/structure-pro/accessibilite.svg';
import SwitchInput from '../../../../common/inputs/SwitchInput';
import parkingIcon from '../../../../../img/structure-pro/parking.svg';
import elevatorIcon from '../../../../../img/structure-pro/ascenseur.svg';
import handicapIcon from '../../../../../img/structure-pro/handicap.svg';

type Props = {
  defaultChecked: boolean[],
  isManager: boolean,
};

function StructureAccessibility(props: Props): ReactElement {
  return (
    <div className="structure-container structure-contact">
      <div className="structure-illustration-container">
        <div className="container-img structure-illustration">
          <img
            className="structure-illustration"
            src={image}
            alt="ILLUSTRATION"
          />
        </div>
      </div>
      <div className="structure-drawer-title-container">
        <div className="structure-drawer-title">
          <Translate value="STRUCTURE_INFORMATION.ACCESSIBILITY" />
        </div>
        <div className="structure-accessibility-form">
          <div className="structure-accessibility-row">
            <div className="accessibility-icon">
              <img
                src={parkingIcon}
                alt="parking"
              />
            </div>
            <Translate value="STRUCTURE_INFORMATION.PARKING" />
            <Field
              type="checkbox"
              name="clientParking"
              placeholder={I18n.t('STRUCTURE_INFORMATION.PARKING')}
              render={({ input: { name, onChange, checked } }) => (
                <SwitchInput
                  name={name}
                  defaultChecked={props.defaultChecked.shift()}
                  checked={checked}
                  onChange={onChange}
                  disabled={!props.isManager}
                />
              )}
            />
          </div>
          <div className="structure-accessibility-row">
            <div className="accessibility-icon">
              <img
                src={elevatorIcon}
                alt="parking"
              />
            </div>
            <Translate value="STRUCTURE_INFORMATION.ELEVATOR" />
            <Field
              type="checkbox"
              name="elevator"
              placeholder={I18n.t('STRUCTURE_INFORMATION.ELEVATOR')}
              render={({ input: { name, onChange, checked } }) => (
                <SwitchInput
                  name={name}
                  defaultChecked={props.defaultChecked.shift()}
                  checked={checked}
                  onChange={onChange}
                  disabled={!props.isManager}
                />
              )}
            />
          </div>
          <div className="structure-accessibility-row">
            <div className="accessibility-icon">
              <img
                src={handicapIcon}
                alt="parking"
              />
            </div>
            <Translate value="STRUCTURE_INFORMATION.HANDICAP" />
            <Field
              type="checkbox"
              name="handicapAccess"
              placeholder={I18n.t('STRUCTURE_INFORMATION.HANDICAP')}
              render={({ input: { name, onChange, checked } }) => (
                <SwitchInput
                  name={name}
                  defaultChecked={props.defaultChecked.shift()}
                  checked={checked}
                  onChange={onChange}
                  disabled={!props.isManager}
                />
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default StructureAccessibility;
